export default [
  {
    title: 'Obras',
    route: 'dashboard',
    icon: 'BriefcaseIcon',
  },
  {
    title: 'Trabajos',
    route: 'jobs',
    icon: 'ClipboardIcon',
  },
  {
    title: 'Tareas',
    route: 'tasks',
    icon: 'CalendarIcon',
  },
  {
    title: 'Producción',
    route: 'production',
    icon: 'CheckSquareIcon',
  },
  {
    title: 'Parte de horas',
    route: 'partesOperario',
    icon: 'ClockIcon',
  },
  {
    title: 'Trazabilidad',
    route: 'traceabilitiesLogs',
    icon: 'ActivityIcon',
  },
  {
    title: 'Gestión',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Usuarios',
        route: 'users',
      },
      {
        title: 'Clientes',
        route: 'clients',
      },
      {
        title: 'Categorías',
        route: 'categories',
      },
      {
        title: 'Departamentos',
        route: 'departments',
      },
      {
        title: 'Calendario laboral',
        route: 'calendario',
      },
      {
        title: 'Notificaciones',
        route: 'notificaciones',
      },
      {
        title: 'Datos empresa',
        route: 'config',
      },
      {
        title: 'Política de registro horario',
        route: 'policy',
      },
    ],
  },
]
